import { PropsWithChildren } from 'react';
import { Typography } from '@/components/Atoms';
import { ArrowLeftSvg } from '@/components/Svg';

type IProps = PropsWithChildren<{ onBackButtonClick: () => void }>;

const TopBarAdditionalData = (props: IProps) => (
  // <motion.div
  //   initial={{ y: 20, opacity: 0 }}
  //   animate={{ y: 0, opacity: 1 }}
  //   exit={{ y: -20, opacity: 0 }}
  //   className='flex py-3 border-y border-[#4F4F4F] mt-3 mb-3'
  // >
  //   <button onClick={props.onBackButtonClick} className='flex flex-shrink-0 items-center gap-1'>
  //     <ArrowLeftSvg className='h-5 text-[#A3A3A3]' />
  //     <Typography size='s16ToS14'>Back</Typography>
  //   </button>

  //   <div className='flex flex-1 px-10'>{props.children}</div>
  // </motion.div>
  <>
    <button onClick={props.onBackButtonClick} className='flex flex-shrink-0 items-center gap-1'>
      <ArrowLeftSvg className='h-5 text-[#A3A3A3]' />
      <Typography size='s16ToS14'>Back</Typography>
    </button>

    <div className='flex flex-1 px-10'>{props.children}</div>
  </>
);

export default TopBarAdditionalData;
